<template>
    <div class="yk-source-preview">
        <!-- 视频预览 -->
        <el-dialog
          title="视频播放"
          :visible.sync="dialogVisible"
          :before-close="handleClose"
          width="1000px"
          :append-to-body="appendStatus"
          color="white"
          :close-on-click-modal="false"
          :close-on-press-escape="false">
            <div class="videoCon">
                <video v-if="videoCurrentShow" id="videoShow" ref="videoShow" controls="controls" autoplay="autoplay" style="max-width:90%;height:100%;">
                    <source :src="courceSourceUrl" type="video/mp4"/>
                </video>
            </div>
        </el-dialog>
       <!-- html文件预览 -->
        <el-dialog
          title="文件预览"
          :visible.sync="htmldialogVisible" 
           width="1000px"
          :before-close="closeHtml"
          :append-to-body="appendStatus"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
            <div style="height:6000px;position:relative;" class="html-fullScreen-show" ref="htmlFullScreenShow">
                <i style="position:absolute;top:-63px;right:36px;font-size:20px;" class="el-icon-rank"  @click="htmlLaunchFullscreen()"></i>
                <iframe ref="htmlIframeShow" v-if="currentHtml" :src="htmlShowUrl" frameborder="0" width="100%" height="100%"></iframe>
            </div>
        </el-dialog>

        <!-- 图片预览 -->
        <div class="img-preview" v-if="imageShow">
            <i class="el-icon-close" @click="closeImageShow"></i>
            <viewer
                :options="Options"
                :images="images"
                @inited="inited"
                class="viewer" ref="viewer">
                <template slot-scope="scope">
                <img v-for="(value,key) in scope.images" :src="value" :key="key">
                </template>
            </viewer>
        </div>
         <!-- 音频预览 -->
        <el-dialog
            title=""
            :visible.sync="audioVisible"
            width="500px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :before-close="closeAudio"
            :append-to-body="appendStatus">
            <div style="text-align:center;">
               <audio v-if="audioCurrentShow" :src="courceSourceUrl" controls="controls" ref="audioSourceDom">
               </audio>
            </div>
        </el-dialog>

        <!-- 转换为图片后的预览方式 -->
         <div class="img-preview" v-if="pptImageShow">
            <i class="el-icon-close" @click="closePptImageShow"></i>
            <viewer
                :options="Options"
                :images="pptImages"
                @inited="inited"
                class="viewer" ref="viewer">
                <template slot-scope="scope">
                    <img v-for="(value,key) in newScope.htmlPictrueList" :src="value" :key="key">
                </template>
            </viewer>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
// import pdf from "vue-pdf";
import { Loading } from "element-ui";
import { getPictureList } from "api/v1.common.picturelist.ts";
export default {
  name: "sourcePreview",
  // components: {
  //   pdf
  // },
  props: {
    data: {
      type: Object,
      default: ""
    }
  },
  data() {
    return {
      Options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        dialogVisible: false,
        url: "data-source"
      },
      images: [],
      CoursewareType: "",
      courceSourceUrl: "",
      videoShow: false,
      isshowpdf: false,
      imageShow: false,
      dialogVisible: false,
      htmldialogVisible: false,
      audioVisible: false,
      pdfSourceShow: false,
      videoCurrentShow: false,
      audioCurrentShow: false,
      pdfCurrentShow: false,
      currentHtml: false,
      fullscreen: false,
      appendStatus: true,
      fullScreenShow: false,
      pptImageShow: false,
      scope: {
        image: []
      },
      newScope: {
        htmlPictrueList: []
      },
      pptImages: [],
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      src: "",
      loading: false,
      htmlShowUrl:
        "http://114.55.179.40:80/xyd/g@A28CABD136D29427ED6AFC2344CDA134.ppt/html/html.html"
    };
  },
  watch: {
    data(val) {
      let sourceUrl = val.url;
      let sourceType = val.docType;
      this.CoursewareType = sourceType;
      this.courceSourceUrl = sourceUrl;
      //图片
      if (sourceType == 1) {
        this.imageShow = true;
        this.images.push(this.courceSourceUrl);
        this.scope.image.push(this.courceSourceUrl);
      }
      //pdf,ppt
      if (sourceType == 2) {
        getPictureList(val.id).then(res => {
          if (!res.list) {
            this.$message("稍等文件未转换完成！");
          } else {
            this.pptImageShow = true;
            for (let i = 0; i < res.list.length; i++) {
              this.pptImages.push(res.list[i].picpath);
              this.newScope.htmlPictrueList.push(res.list[i].picpath);
            }
            console.log(this.pptImages.push(res.list[i].picpath));
          }
        });
      }
      //视频
      if (sourceType == 3) {
        this.videoCurrentShow = true;
        this.dialogVisible = true;
      }
      //音频
      if (sourceType == 4) {
        this.audioVisible = true;
        this.audioCurrentShow = true;
      }
      //html
      if (sourceType == 5) {
        getPictureList(val.id).then(res => {});
        this.htmldialogVisible = true;
        this.currentHtml = true;
      }
    },
    numPages(val) {
      if (val > 0) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    }
  },
  methods: {
    closePptImageShow() {
      this.pptImages = [];
      this.newScope.htmlPictrueList = [];
      this.pptImageShow = false;
    },
    closepdf() {
      this.isshowpdf = false;
    },
    pdferr(errurl) {
      console.log(errurl);
    },
    show: function() {
      const viewer = this.$el.querySelector(".images").$viewer;
      viewer.show();
    },
    handleClose: function() {
      this.dialogVisible = false;
      this.videoCurrentShow = false;
      this.$refs.videoShow.pause();
    },
    inited: function(viewer) {
      this.$viewer = viewer;
    },
    show: function() {
      this.$viewer.show();
    },
    closeImageShow: function() {
      this.imageShow = false;
      this.images = [];
    },
    closeAudio: function() {
      this.audioVisible = false;
      this.audioCurrentShow = false;
      this.$refs.audioSourceDom.pause();
    },
    prevPage: function() {
      //   this.page -= 1;
      //   console.log(this.page);
      //   console.log(this.numPages);
      if (this.page <= this.numPages) {
        this.page -= 1;
      }
      if (this.page <= 1) {
        this.page = 1;
      }
    },
    nextPage: function() {
      this.page += 1;
      if (this.page >= this.numPages) {
        this.page = this.numPages;
      }
    },
    closePdf: function() {
      this.page = 1;
      this.numPages = 0;
      this.pdfSourceShow = false;
      this.pdfCurrentShow = false;
    },
    password: function(updatePassword, reason) {
      updatePassword(prompt('password is "test"'));
    },
    error: function(err) {
      console.log(err);
    },
    closeHtml: function() {
      this.htmldialogVisible = false;
      this.currentHtml = false;
    },
    // pdf全屏预览
    pdfLaunchFullscreen: function() {
      var element = this.$refs.pdfFullScreen;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    // html全屏预览
    htmlLaunchFullscreen: function() {
      var element = this.$refs.htmlIframeShow;
      //   element.style.width = "1200px";
      //   element.style.height = "800px";
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
  div {
    div {
      div {
        overflow: hidden;
      }
    }
  }
}
.yk-source-preview {
  .yk-video-preview {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1004;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .videoCon {
    margin: 0 auto;
    width: 670px;
    height: 350px;
    video {
      object-fit: fill;
    }
  }
  .img-preview {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1010;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    .el-icon-close {
      position: absolute;
      right: 50px;
      top: 5px;
      z-index: 3000;
      color: white;
      font-size: 25px;
      cursor: pointer;
      font-weight: bolder;
    }
    .viewer {
      display: none;
    }
  }
  .yk-audio-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1030;
    background-color: rgba(0, 0, 0, 0.4);
    audio {
      display: block;
      margin: 0 auto;
      margin-top: 200px;
    }
  }
  .yk-pdf-show {
    overflow: auto;
    position: relative;
    .yk-close-pdf {
      position: absolute;
      right: 30px;
      top: -65px;
      font-size: 20px;
    }
    .pdfHead {
      text-align: center;
      span {
        font-size: 20px;
      }
      .sp-currentPage,
      .sp-totalPage {
        padding: 0 10px;
        span {
          font-size: 20px;
        }
      }
    }
  }
}
</style>

